module.exports = __webpack_public_path__ + "img/icon-pubgm.7ab60cb.png";